import { gql } from '@apollo/client';

/**
 * One turn of the conversation with the stock analyst: the message goes out,
 * the turn streams back as events — agent text, tool calls (`toolName`), a new
 * report revision when the agent edits it (`revisionId`), or an action it
 * proposes (`pendingActionId` + `confirmationToken` + `preview`). Every turn
 * ends with DONE; an ERROR comes first when the role or session check fails.
 * Needs the research-analyst role.
 */
export const STOCK_RESEARCH_CHAT = gql`
  subscription StockResearchChat($sessionId: Int!, $message: String!, $surface: String = "app") {
    stockResearchChat(sessionId: $sessionId, message: $message, surface: $surface) {
      type
      text
      toolName
      revisionId
      pendingActionId
      preview
      confirmationToken
      sessionId
      data
    }
  }
`;
